import styled from 'styled-components';
const twoColumnBreakpoint = 'min-width: 744px';
const threeColumnBreakpoint = 'min-width: 1104px';
const One = styled.div.withConfig({ displayName: "brc-sc-One", componentId: "brc-sc-9ykpsm" }) ``;
const OneFewer = styled.div.withConfig({ displayName: "brc-sc-OneFewer", componentId: "brc-sc-1b7ok02" }) `
  @media (${threeColumnBreakpoint}) {
    grid-column: span 2;
  }
`;
const OneTwoOne = styled.div.withConfig({ displayName: "brc-sc-OneTwoOne", componentId: "brc-sc-rlvso1" }) `
  grid-column: span 1;

  @media (${twoColumnBreakpoint}) {
    grid-column: span 2;
  }

  @media (${threeColumnBreakpoint}) {
    grid-column: span 1;
  }
`;
const Two = styled.div.withConfig({ displayName: "brc-sc-Two", componentId: "brc-sc-1ee8bxj" }) `
  @media (${twoColumnBreakpoint}) {
    grid-column: span 2;
  }
`;
const All = styled.div.withConfig({ displayName: "brc-sc-All", componentId: "brc-sc-10kx32h" }) `
  @media (${twoColumnBreakpoint}) {
    grid-column: span 2;
  }

  @media (${threeColumnBreakpoint}) {
    grid-column: span 3;
  }
`;
const _ThreeColumnLayout = styled.div.withConfig({ displayName: "brc-sc-_ThreeColumnLayout", componentId: "brc-sc-1ozx1zt" }) `
  align-items: start;
  max-width: 1056px;
  margin: 0 auto;
  display: grid;
  padding: 16px;
  grid-gap: 16px;
  grid-template-columns: 1fr;

  @media (${twoColumnBreakpoint}) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 24px;
    padding: 24px;
  }

  @media (${threeColumnBreakpoint}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
export const ThreeColumnLayout = _ThreeColumnLayout;
ThreeColumnLayout.One = One;
ThreeColumnLayout.OneFewer = OneFewer;
ThreeColumnLayout.OneTwoOne = OneTwoOne;
ThreeColumnLayout.Two = Two;
ThreeColumnLayout.All = All;
ThreeColumnLayout.twoColumnBreakpoint = twoColumnBreakpoint;
ThreeColumnLayout.threeColumnBreakpoint = threeColumnBreakpoint;
export { One, OneFewer, OneTwoOne, Two, All, twoColumnBreakpoint, threeColumnBreakpoint };
//# sourceMappingURL=three-col-layout.js.map